import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')
	const ex1 = await getThemePic(data?.customTheme, 'ex-1')
	const ex2 = await getThemePic(data?.customTheme, 'ex-2')


	return {
		"id": id,
		"elements": [
			{
				"type": "image",
				"id": "K9HAihE0zD",
				"src": ex1,
				"width": 1000,
				"height": 562.5,
				"left": 0,
				"top": 0,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "1_509x2jOO",
				"src": ex1,
				"width": 457.71,
				"height": 378.7,
				"left": 519.69,
				"top": 140.16,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "text",
				"id": "a0JeAUuajd",
				"width": 523.6,
				"height": 117.953125,
				"left": 38.47,
				"top": 121.8,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"\"><span style=\"font-size: 97.96px;\"><span style=\"font-family: 方正正大黑简体;\"><span style=\"color: rgba(255,251,251,1);\">谢谢观看</span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "RzbyB-9JvX",
				"width": 199.30178784266985,
				"height": 40.375,
				"left": 48.52,
				"top": 345.60280095351607,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": "<p style=\"\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: rgba(249,240,240,1);\">汇报人：ChatGpt</span></span></span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "SpcqPVBjRz",
				"width": 161.26113230035756,
				"height": 40.375,
				"left": 260.5909177592372,
				"top": 345.60280095351607,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": "<p style=\"\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: rgba(255,255,255,1);\">时间：202X/XX</span></span></span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	};
}